// extracted by mini-css-extract-plugin
export default {"cardItem":"style_cardItem__-V1iW","value":"style_value__1+66Y","text":"style_text__GCpyG","positive":"style_positive__g2WWi","negative":"style_negative__G3kO3"};